// extracted by mini-css-extract-plugin
export default {"main":"PlayCartoon_main__kdTh0","playlist_cartoon":"PlayCartoon_playlist_cartoon__vDA8i","smilar_max_height":"PlayCartoon_smilar_max_height__G52j4"};